import { LinearProgress, withStyles, FormHelperText as MaterialFormHelperText } from '@material-ui/core';

export const StyledFormHelperText = withStyles(({ typography, palette }) => ({
  root: {
    ...typography.caption,
    color: palette.error.main,
    padding: '0 15px',
  },
  // @ts-expect-error - Material-UI v4 styled component type conflict with React 18
}))(MaterialFormHelperText);

export const StyledLinearProgress = withStyles(({ palette }) => ({
  root: {
    width: '100%',
    height: 20,
    backgroundColor: palette.green.light,
    borderRadius: 10,
    margin: '20px 0',
  },
  bar: {
    borderRadius: 20,
    backgroundColor: palette.green.main,
  },
  // @ts-expect-error - Material-UI v4 styled component type conflict with React 18
}))(LinearProgress);
